import { createReducer } from 'typesafe-actions';
import { IsFacebookOnlyUserState } from '../types';
import { isFacebookOnlyUserActions, IsFacebookOnlyUserActions } from './actions';

const isFacebookOnlyUserReducer = createReducer<IsFacebookOnlyUserState, IsFacebookOnlyUserActions>({
    isFetching: false,
    didInvalidate: false,
    isFacebookOnlyUser: false,
})
    .handleAction(isFacebookOnlyUserActions.request, state => ({
        ...state,
        isFetching: true,
    }))
    .handleAction(isFacebookOnlyUserActions.success, (state, action) => ({
        ...state,
        isFetching: false,
        didInvalidate: false,
        isFacebookOnlyUser: action.payload,
    }))
    .handleAction(isFacebookOnlyUserActions.failure, state => ({
        ...state,
        isFetching: false,
        didInvalidate: true,
    }));

export default isFacebookOnlyUserReducer;
